import { useEffect } from 'react';

/**
 * 新しいランディングページは public/landing.html に静的HTMLとして配置済み。
 * このコンポーネントは / 訪問時に landing.html へリダイレクトする役割のみを持つ。
 *
 * ・LP からの「ログイン / 登録」「無料で始める」「プランを選ぶ」は landing.html 内で
 *   href="/#app" を指しており、戻ってきた際に App.jsx が LoginPage を表示する。
 * ・onStart prop は後方互換のため残しているが現状は使用しない。
 *
 * 旧 React 版 LP は LandingPage.legacy.jsx として保管。
 */
export default function LandingPage(/* { onStart } */) {
  useEffect(() => {
    // Electron（file://）では絶対パス /landing.html が file:///C:/landing.html に
    // 解決されてしまい 404 になる。デスクトップ版はマーケ LP を挟まず直接アプリ
    // （#app → 未ログインなら LoginPage）へ遷移させる。
    const isElectron = !!window.electronAPI || window.location.protocol === 'file:';
    if (isElectron) {
      window.location.hash = '#app';
      return;
    }
    // location.replace で履歴に残さず置き換え（戻るボタンで戻ってこないように）
    window.location.replace('/landing.html');
  }, []);

  // リダイレクト発火までの一瞬の白フラッシュを抑える簡易プレースホルダ
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'linear-gradient(160deg, #FDF2F8 0%, #FFFFFF 50%, #F3E8FF 100%)',
        zIndex: 9999,
      }}
      aria-hidden="true"
    />
  );
}
